import React from 'react'

import { Button, Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'
import { ReactComponent as CheckIcon } from 'static/svg/green-check.svg'

import * as S from './styles'

export interface SimpleSuccessModalProps {
  title: string
  onClose: () => void
  hasButton?: boolean
  buttonText?: string
  onClick?: () => void
}

export const SimpleSuccessModal: React.FC<SimpleSuccessModalProps> = ({
  title,
  onClose,
  buttonText = '',
  hasButton = false,
  onClick = () => null,
}) => {
  return (
    <ModalGeneric
      modalTitle={
        <S.HeaderWrapper>
          <CheckIcon />
          <Typography variant='content1' weight='bold'>
            {title}
          </Typography>
        </S.HeaderWrapper>
      }
      onCloseModal={onClose}
      hasCloseButton
    >
      <S.SimpleSuccessModalContainer>
        {hasButton && buttonText && (
          <Button
            onClick={onClick}
            uppercase={false}
            variant='outlined'
          >
            {buttonText}
          </Button>
        )}
      </S.SimpleSuccessModalContainer>
    </ModalGeneric>
  )
}